import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntryPackageOrderListQueryVariables = Types.Exact<{
  market: Types.Scalars['String']['input'];
  orderId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  customerName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  phoneNumber?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderStartDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderEndDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type EntryPackageOrderListQuery = { __typename?: 'Query', entryPackageOrderList: Array<{ __typename?: 'EntryPackageOrderListResult', memberNo?: string | null, customerName: string, phoneNumber: string, email: string, zipCode?: string | null, fullAddress?: string | null, sggCd?: string | null, roadCd?: string | null, emdCd?: string | null, buldNo?: string | null, productCode: string, packageNo: string, orderId: string, easyPayCno: string, paymentAmount: number, paidAmount: number, paymentStatus: string, paymentDate?: any | null, canceledDate?: any | null, paymentMethod: string, isAdvertisingInfoAgreed: boolean, isMarketingInfoCollectionAgreed: boolean, createdAt: any, memberPaymentInfo: { __typename?: 'EntryPackageOrdersMemberPaymentInfoResult', paymentInfoId: number, paymentType: any, accountHolderName: string, birthDate: string, bankCode: string, bankName: string, creditCardBankCode: string, creditCardBankName: string, paymentNumberEncrypted: string, paymentNumber: string, displayMask: string, expiryMonth?: string | null, expiryYear?: string | null } }> };


export const EntryPackageOrderListDocument = gql`
    query EntryPackageOrderList($market: String!, $orderId: String, $customerName: String, $phoneNumber: String, $orderStartDate: String, $orderEndDate: String) {
  entryPackageOrderList(
    parameter: {market: $market, orderId: $orderId, customerName: $customerName, phoneNumber: $phoneNumber, orderStartDate: $orderStartDate, orderEndDate: $orderEndDate}
  ) {
    memberNo
    customerName
    phoneNumber
    email
    zipCode
    fullAddress
    sggCd
    roadCd
    emdCd
    buldNo
    productCode
    packageNo
    orderId
    easyPayCno
    paymentAmount
    paidAmount
    paymentStatus
    paymentDate
    canceledDate
    paymentMethod
    isAdvertisingInfoAgreed
    isMarketingInfoCollectionAgreed
    createdAt
    memberPaymentInfo {
      paymentInfoId
      paymentType
      accountHolderName
      birthDate
      bankCode
      bankName
      creditCardBankCode
      creditCardBankName
      paymentNumberEncrypted
      paymentNumber
      displayMask
      expiryMonth
      expiryYear
    }
  }
}
    `;

/**
 * __useEntryPackageOrderListQuery__
 *
 * To run a query within a React component, call `useEntryPackageOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntryPackageOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntryPackageOrderListQuery({
 *   variables: {
 *      market: // value for 'market'
 *      orderId: // value for 'orderId'
 *      customerName: // value for 'customerName'
 *      phoneNumber: // value for 'phoneNumber'
 *      orderStartDate: // value for 'orderStartDate'
 *      orderEndDate: // value for 'orderEndDate'
 *   },
 * });
 */
export function useEntryPackageOrderListQuery(baseOptions: Apollo.QueryHookOptions<EntryPackageOrderListQuery, EntryPackageOrderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntryPackageOrderListQuery, EntryPackageOrderListQueryVariables>(EntryPackageOrderListDocument, options);
      }
export function useEntryPackageOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntryPackageOrderListQuery, EntryPackageOrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntryPackageOrderListQuery, EntryPackageOrderListQueryVariables>(EntryPackageOrderListDocument, options);
        }
export type EntryPackageOrderListQueryHookResult = ReturnType<typeof useEntryPackageOrderListQuery>;
export type EntryPackageOrderListLazyQueryHookResult = ReturnType<typeof useEntryPackageOrderListLazyQuery>;
export type EntryPackageOrderListQueryResult = Apollo.QueryResult<EntryPackageOrderListQuery, EntryPackageOrderListQueryVariables>;